/**
 * claimReportFormSchema.js
 */
import { DATE_TIME_FORMAT_REG_EXP } from "utils/datetime";
export const claimReportFormSchema = [
  {
    id: "startDateTime",
    group: "Period & Status",
    label: "From",
    disabled: true,
    fieldType: "datetime",
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    value: "",
    pattern: DATE_TIME_FORMAT_REG_EXP,
  },
  {
    id: "endDateTime",
    group: "Period & Status",
    label: "To",
    disabled: true,
    fieldType: "datetime",
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    value: "",
    pattern: DATE_TIME_FORMAT_REG_EXP,
  },
  {
    id: "status",
    group: "Period & Status",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Status",
    value: "Success",
    isRequired: false,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "", label: "All" },
      { value: "Success", label: "Success" },
      { value: "Reversed", label: "Reversed" },
    ],
  },
  {
    id: "submittedThrough",
    group: "Offline",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Offline/Online",
    value: "Online",
    isRequired: false,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "", label: "All" },
      { value: "n", label: "Online" },
      { value: "y", label: "Offline" },
    ],
  },
  {
    id: "cardNumber",
    group: "Policy Holder Information",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Card Number",
    value: "",
    isRequired: false,
    fieldType: "textfield",
    pattern: /^\d{16}$/,
    patternMessage: "Invalid card number. It should be 16 digits.",
    onKeyDown: (e, value, deps) => {
      if (e.key === "Enter" && value) {
        e.preventDefault();
        deps.onFetchCardDetails(value);
      }
    },
  },
  {
    id: "policyNumber",
    group: "Policy Holder Information",
    label: "Policy",
    disabled: false,
    fieldType: "Text",
    shownOnForm: true,
    width: "60%",
    isRequired: false,
    value: "",
    fieldType: "textfield",
  },
  {
    id: "terminalId",
    group: "Claim Details",
    label: "Hospital/Provider",
    fieldType: "autocomplete",
    shownOnForm: true,
    width: "60%",
    isRequired: false,
    valueKey: "id",
    textValue: "label",
    onSearch: (query, deps) => {},
    options: (deps) => deps.terminals || [],
    loading: (deps) => deps.terminalsLoading,
    onInputChange: (searchValue, deps) => {},
  },
  {
    id: "referenceId",
    group: "Claim Details",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Reference",
    value: "",
    isRequired: false,
    fieldType: "textfield",
  },
];

export const claimReportRecord = {
  id: null,
  cardNumber: "",
  policyNumber: "",
  terminalId: null,
  referenceId: "",
  status: "Success",
  externalErrors: {},
};
